module.exports = __webpack_public_path__ + "media/images/flags/1x1/smr-507d97404dd7886c8b1d25920433b60c.svg";